// extracted by mini-css-extract-plugin
export default {"expandedMode":"calendar_display-module___expandedMode___a2c0fc3b"};